import { render, staticRenderFns } from "./FbCopyInfluencerLinks.vue?vue&type=template&id=2855ff0c&scoped=true"
import script from "./FbCopyInfluencerLinks.vue?vue&type=script&lang=js"
export * from "./FbCopyInfluencerLinks.vue?vue&type=script&lang=js"
import style0 from "./FbCopyInfluencerLinks.vue?vue&type=style&index=0&id=2855ff0c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2855ff0c",
  null
  
)

export default component.exports